
// Copyright (c) Microsoft Corporation.
// Licensed under the MIT License.

// This file provides the provides functionality to get Microsoft Graph data.

/* global console fetch */

/**
 *  Calls a Microsoft Graph API and returns the response.
 *
 * @param accessToken The access token to use for the request.
 * @param path Path component of the URI, e.g., "/me". Should start with "/".
 * @param queryParams Query parameters, e.g., "?$select=name,id". Should start with "?".
 * @returns
 */
export async function getGraphData(accessToken: string, url: string): Promise<any> {
    if (!url) throw new Error("url is required.");
    const response = await fetch(url, {
      headers: { Authorization: `Bearer ${accessToken}` },
    });
  
    if (response.ok) {
      const data = await response.json();
      // console.log("✅ Store: Got iCalUId and customUid:", data);
      return data;
    } else {
      throw new Error(response.statusText);
    }
  }
  